import { render, staticRenderFns } from "./right2.vue?vue&type=template&id=a837f776&scoped=true&"
import script from "./right2.vue?vue&type=script&lang=js&"
export * from "./right2.vue?vue&type=script&lang=js&"
import style0 from "./right2.vue?vue&type=style&index=0&id=a837f776&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a837f776",
  null
  
)

export default component.exports